import { useFormikContext } from 'formik';

import { Box } from '@hivebrite/design-system/Box';

import { IsActive } from 'hb-react/shared/components/IsActive';

import { Notify } from './Notify';
import { Submit } from './Submit';
import { MODE } from '../constants';
import { type FormValues, type Job, type ModeValues } from '../types';

export const Actions = ({
  job,
  mode,
}: {
  job: Job;
  mode: ModeValues;
  networkId: number;
  topicId?: number;
}) => {
  const { values } = useFormikContext<FormValues>();

  const isPending =
    mode === MODE.BO &&
    values.status === 'pending' &&
    values.type_class === 'BusinessOpportunities::ExternalRecruiterRequest';

  const canSubmit = !(isPending || values.status === 'rejected');

  const margins = {
    mt: { s: 4, m: 6 },
    mx: { s: 2, m: 0 },
    pb: { s: 8, m: 18 },
  };

  return (
    <Box justifyContent="flex-end" {...margins}>
      <IsActive isActive={mode === MODE.FO}>
        <Notify job={job} />
      </IsActive>
      <IsActive isActive={canSubmit}>
        <Submit mode={mode} />
      </IsActive>
    </Box>
  );
};
